export function getPageNumber(first: number, rows: number): number {
  let page: number = 1;

  first = first < 1 ? 1 : first;

  if (first > 1) {
    page = first / rows + 1;
  }

  return page;
}
